import _styled from "styled-components";
var _excluded = ["style", "isOpen", "getMenuProps", "overlayProps", "targetProps", "renderWrapper", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { pickKeys, stylePropType } from '@adsk/alloy-helpers';
import Overlay from '@adsk/alloy-overlay';
import theme from '@adsk/alloy-theme';
var menuStyle = {
  maxHeight: 300,
  boxShadow: theme.shadows.highElevation,
  overflowY: 'auto'
};
var Menu = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var style = _ref.style,
      isOpen = _ref.isOpen,
      getMenuProps = _ref.getMenuProps,
      overlayProps = _ref.overlayProps,
      targetProps = _ref.targetProps,
      renderWrapper = _ref.renderWrapper,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var renderContent = function renderContent(_ref2) {
    var _targetProps$ref, _targetProps$ref$curr;

    var internalStyle = _ref2.internalStyle;
    return /*#__PURE__*/React.createElement(_StyledUl, _extends({
      ref: ref
    }, getMenuProps === null || getMenuProps === void 0 ? void 0 : getMenuProps(), props, {
      $_css: [theme.typography.labelMedium, {
        position: 'relative',
        listStyleType: 'none',
        userSelect: 'none',
        outline: 'none',
        padding: 0,
        margin: 0,
        borderRadius: 4,
        maxWidth: 'calc(100% + 70px)',
        width: targetProps === null || targetProps === void 0 ? void 0 : (_targetProps$ref = targetProps.ref) === null || _targetProps$ref === void 0 ? void 0 : (_targetProps$ref$curr = _targetProps$ref.current) === null || _targetProps$ref$curr === void 0 ? void 0 : _targetProps$ref$curr.offsetWidth,
        backgroundColor: theme.colors.white
      }, internalStyle, style]
    }), isOpen && children, /*#__PURE__*/React.createElement("div", {
      tabIndex: 0
    }));
  };

  return /*#__PURE__*/React.createElement(Overlay.Container, _extends({
    "data-testid": 'Dropdown__menu'
  }, overlayProps), renderWrapper ? renderWrapper({
    style: menuStyle,
    children: renderContent({})
  }) : renderContent({
    internalStyle: menuStyle
  }));
});
Menu.displayName = 'Menu';
Menu.propTypes = _objectSpread(_objectSpread({}, pickKeys(Overlay.propTypes, ['placement'])), {}, {
  /** Styles applied to the root element */
  style: stylePropType,

  /** Class applied to the root element */
  className: PropTypes.string,

  /** The content of the Menu */
  children: PropTypes.node,

  /** Whether Dropdown menu is open */
  isOpen: PropTypes.bool.isRequired,

  /** Props applied to the control (overlay target).  This is returned from useOverlay */
  targetProps: PropTypes.shape({
    ref: PropTypes.any
  }).isRequired,

  /**
   * Render a component that will wrap the <ul> element, but still be contained within the overlay.
   * Use this is to enable virtualization
   */
  renderWrapper: PropTypes.func
});
export default Menu;

var _StyledUl = _styled("ul").withConfig({
  displayName: "Menu___StyledUl",
  componentId: "sc-1xv56nt-0"
})(["", ""], function (p) {
  return p.$_css;
});
//# sourceMappingURL=Menu.js.map